<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">店员补贴&nbsp;/&nbsp;</span>
      </div>
      <div>店员权益</div>
    </div>
    <div class="page-head">
      <el-table :data="list" :max-height="height - 160" header-cell-class-name="table_header_bgcolor">
        <el-table-column prop="staffHeadImg" label="头像">
          <template slot-scope="scope">
            <img :src="scope.row.headImgUrl ? scope.row.headImgUrl : headImg" alt="" class="staffImg">
          </template>
        </el-table-column>
        <el-table-column prop="staffInfo" label="员工信息" width="auto"></el-table-column>
        <el-table-column prop="subsidyInfo" width="auto" label="申请信息"></el-table-column>
        <el-table-column prop="amt" label="操作" align="left" width="100">
          <template slot-scope="scope">
            <el-link type="primary" @click="details(scope.row)">详情</el-link>
          </template>
        </el-table-column>
      </el-table>
      <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
    </div>
    <detail ref="detailForm" @change="handleChange"></detail>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "./components/equitiesDetails.vue";
export default {
  data() {
    return {
      url: this.$url.subsidyApply.staffSubsidyRightList,
      urlCount: this.$url.subsidyApply.staffSubsidyRightCount,
      headImg: require("../../../assets/images/headerImg.png"),
      height: this.$store.getters.MainHeight,
      list: [],
      query: {
        start: 0,
        size: 20
      },
    };
  },
  mixins: [minxin],
  components: { detail },
  mounted() {
    this.totalCounts();
  },

  methods: {
    details (row) {
      this.$refs["detailForm"].init(row.staffId)
    },
    handleChange(bool) {
      this.totalCounts();
    },
    selectChange() {
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.urlCount, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => { });
    },
    back () {
      this.$router.push("/dataList/staffSubsidy");
    }
  }
};
</script>